import { Col, Container, Row, Spinner } from "react-bootstrap";
import { useGlobal } from "../../GlobalContext";
import { useUI } from "../../UIContext";
import Sidebar from "../Sidebar/Sidebar";
import Topbar from "../Topbar/Topbar";
import "./summary.css";
import { ReactComponent as RegionIcon } from "../../Assets/svg/Region_Ic.svg";
import { useCallback, useEffect, useState } from "react";
import { exportquickApi, getSummaryListApi } from "./summary-api";
import ReactPaginate from "react-paginate";
import lar from "../../Assets/svg/lar.svg";
import rar from "../../Assets/svg/rar.svg";
import ExportBtn from "../../Assets/svg/export_btn.svg";
import { downloadBase64File } from "../Reports/report-api";
import EditIocns from "../../Assets/svg/single_edit_ic.svg";
import { ReactComponent as SearchBox } from "../../Assets/svg/chat-bot/Search.svg";
import project_based_tic from "../../Assets/svg/project_based_tic.svg";
import component_ticket_ic from "../../Assets/svg/component_ticket_ic.svg";
import customer_ic from "../../Assets/svg/customer_ic.svg";
import vendor_ticker_ic from "../../Assets/svg/vendor_ticker_ic.svg";
import priorty_ticket_ic from "../../Assets/svg/priorty_ticket_ic.svg";
import expected_ticket_ic from "../../Assets/svg/expected_ticket_ic.svg";
import created_ticket_ic from "../../Assets/svg/created_ticket_ic.svg";
import region_ticket_ic from "../../Assets/svg/region_ticket_ic.svg";
import unallocated_ticket_ic from "../../Assets/svg/unallocated_ticket_ic.svg";
import open_ticket_ic from "../../Assets/svg/open_ticket_ic.svg";
import inprogress_ticket_ic from "../../Assets/svg/inprogress_ticket_ic.svg";
import hold_ticket_ic from "../../Assets/svg/hold_ticket_ic.svg";
import closed_ticker_ic from "../../Assets/svg/closed_ticker_ic.svg";
import completed_ticket_ic from "../../Assets/svg/completed_ticket_ic.svg";
import approval_based_ic from "../../Assets/svg/approval_based_ic.svg";
import team_baed_ic from "../../Assets/svg/team_baed_ic.svg";
import status_based_ic from "../../Assets/svg/status_based_ic.svg";
import monthly_ticket_ic from "../../Assets/svg/monthly_ticket_ic.svg";
import weekly_ticket_ic from "../../Assets/svg/weekly_ticket_ic.svg";
import reporter_based_ic from "../../Assets/svg/reporter_based_ic.svg";
import location_icon_9c from "../../Assets/svg/location_icon_9c.svg";
export default function SummaryList() {
  const { rolePermissionList } = useGlobal();
  const { isCollapsed } = useUI();
  const summaryTab = [
    { label: "Region", value: "region", apiValue: "region_based_report" },
    { label: "Location", value: "location", apiValue: "location_based_report" },
    { label: "Team", value: "team", apiValue: "team_based_report" },
    { label: "Project", value: "project", apiValue: "project_based_report" },
    {
      label: "Components",
      value: "component",
      apiValue: "component_based_report",
    },
    { label: "Reporter", value: "reporter", apiValue: "reporter_based_report" },
    { label: "Assignee", value: "assignee", apiValue: "assignee_based_report" },
    { label: "Customer", value: "customer", apiValue: "customer_based_report" },
    { label: "Vendor", value: "vendor", apiValue: "vendor_based_report" },
    { label: "Priority", value: "priority", apiValue: "priority_based_report" },
    {
      label: "Expected Date",
      value: "expected_date",
      apiValue: "expected_date_based_report",
    },
    {
      label: "Created Date",
      value: "created_date",
      apiValue: "created_date_based_report",
    },
  ];
  const [loading, setLoading] = useState(false);
  const [selectedtablabel, setSelectedtablabel] = useState("Region");
  const [selectedtab, setSelectedtab] = useState("region");
  const [selectedApitab, setSelectedApitab] = useState("region_based_report");
  const [summaryCount, setsummaryCount] = useState({});
  const [summarylastdate, setsummarylastdate] = useState("");
  const [summaryList, setsummaryList] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10); // or any default value
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [term, setTerm] = useState("");

  const handlePageClick = useCallback(
    (event) => {
      const newOffset = event.selected * Number(itemsPerPage);
      setItemOffset(newOffset); // Not event.selected
    },
    [itemsPerPage],
  );
  const handleChange = (e) => {
    setTerm(e.target.value);
  };

  const getIconByLabel = (label) => {
    switch (label) {
      case "Region":
        return region_ticket_ic;
      case "Location":
        return location_icon_9c;
      case "Team":
        return team_baed_ic;
      case "Reporter":
      case "Assignee":
        return reporter_based_ic;

      case "Project":
        return project_based_tic;
      case "Components":
        return component_ticket_ic;
      case "Priority":
        return priorty_ticket_ic;
      case "Expected date":
        return expected_ticket_ic;
      case "Created date":
        return created_ticket_ic;
      case "Customer":
        return customer_ic;
      case "Vendor":
        return vendor_ticker_ic;

      default:
        return project_based_tic;
    }
  };
  const getSummaryList = async () => {
    try {
      const bodyData = {
        type: selectedtab,
        search: term,
        limit: Number(itemsPerPage),
        skip: itemOffset,
      };

      const response = await getSummaryListApi(bodyData);
      console.log("Summary API Response:", response);

      if (response?.success) {
        setsummaryList(response.data.data || []);
        setsummarylastdate(response.data.last_updated || "");
        setsummaryCount(response.data.sum || {});
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
      } else {
        console.error("Failed to fetch summary list:", response?.message || "Unknown error");
        setsummaryList([]); // fallback to empty list
        setsummarylastdate("");
        setsummaryCount({});
        setTotalCount(0);
        setPageCount(0);
      }
    } catch (error) {
      console.error("Error fetching summary list:", error);
      setsummaryList([]); // fallback to empty list on error
      setsummarylastdate("");
      setsummaryCount({});
      setTotalCount(0);
      setPageCount(0);
    }
  };

  const exportQuickGet = async () => {
    try {
      setLoading(true);

      const response = await exportquickApi(selectedApitab);
      console.log(response);

      if (response.status === 200 && response.data?.success) {
        console.log("inside success");
        const base64String = response.data.base64;
        const fileName = response.data.file_name;

        // Convert Base64 to Blob and download
        downloadBase64File(base64String, fileName);
      } else {
        console.error("Export failed:", response?.data?.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error during export:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSummaryList();
  }, [selectedtab, itemOffset, itemsPerPage, term]);

  return (
    <Container fluid style={{ width: "100%", padding: "0px" }}>
      <div className="d-flex side4">
        <Row sm={12} className="custom-container">
          <Col sm={12}>
            <div className="maincontent">
              <div className="titlebar mb-3">
                <div className="titletoggle mb-3">
                  {summaryTab.map((title, index) => (
                    <div
                      title={title.label}
                      key={index}
                      className={`Box ${selectedtab === title.value ? "active" : ""}`}
                      onClick={() => {
                        setItemOffset(0);
                        setSelectedtablabel(title.label);
                        setSelectedtab(title.value);
                        setSelectedApitab(title.apiValue);
                      }}
                    >
                      {title.label}
                    </div>
                  ))}
                </div>
                <div className="titleCard">
                  <div className="d-flex align-items-center">
                    <div className="titleCardIcon">
                      <img
                        src={getIconByLabel(selectedtablabel)}
                        // style={{ width: "24px" }}
                      />
                    </div>
                    <div className="titleSubCard ms-3">
                      <div className="titleCardName">{selectedtablabel}</div>
                      <div className="titleCardSubline mt-1 ellipsis" title={`Last update on ${summarylastdate}`}>
                        Last update on {summarylastdate}
                      </div>
                    </div>
                  </div>

                  <div className="titleSubCardCount ">
                    <div className="d-flex align-items-center gap-5">
                      <div className="flex-grow-2 text-start">
                        <div className="titleCounttitle">Overall</div>
                        <div className="titleCount mt-1">{summaryCount.total ?? 0}</div>
                      </div>
                      <div className="border-end mx-2" style={{ height: "28px" }}></div>
                      <div className=" flex-grow-2 ">
                        <div className="titleCounttitle">Open</div>
                        <div className="titleCount mt-1">{summaryCount.open ?? 0}</div>
                      </div>
                      <div className="border-end mx-2" style={{ height: "28px" }}></div>
                      <div className=" flex-grow-2 ">
                        <div className="titleCounttitle">In Progress</div>
                        <div className="titleCount mt-1">{summaryCount.in_progress ?? 0}</div>
                      </div>
                      <div className="border-end mx-2" style={{ height: "28px" }}></div>
                      <div className=" flex-grow-2 ">
                        <div className="titleCounttitle">Hold</div>
                        <div className="titleCount mt-1">{summaryCount.hold ?? 0}</div>
                      </div>
                      <div className="border-end mx-2" style={{ height: "28px" }}></div>
                      <div className=" flex-grow-2  me-5">
                        <div className="titleCounttitle">Closed</div>
                        <div className="titleCount mt-1">{summaryCount.closed ?? 0}</div>
                      </div>{" "}
                      <div className="border-end mx-2" style={{ height: "28px" }}></div>
                      <div className=" flex-grow-2  me-5">
                        <div className="titleCounttitle">Completed</div>
                        <div className="titleCount mt-1">{summaryCount.completed ?? 0}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="tablecard">
                <div className="d-flex justify-content-between align-items-center mt-2 mb-4">
                  <div className="recstyle">Records : {totalCount}</div>

                  <div className="search-export-row">
                    {selectedtablabel !== "Created Date" && selectedtablabel !== "Expected Date" && selectedtablabel !== "Priority" && (
                      <div className="search-bar">
                        <SearchBox />
                        <input type="text" placeholder="Search..." value={term} onChange={handleChange} />
                      </div>
                    )}
                    <div className={`exportbtn ${loading ? "disabled" : ""}`} onClick={!loading ? exportQuickGet : undefined}>
                      {loading ? (
                        <>
                          <Spinner animation="border" size="sm" variant="light" className="mx-1" />
                        </>
                      ) : (
                        <>
                          <img src={ExportBtn} alt="" />
                          <span className="exporttext mx-1">Export</span>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div style={{ overflowX: "auto" }}>
                  <div className="tableheader" style={{ minWidth: "900px" }}>
                    <p className="tableheadIndi"> {selectedtablabel}</p>
                    <p className="tableheadIndi">Overall</p>
                    <p className="tableheadIndi">Open</p>
                    <p className="tableheadIndi">InProgress</p>
                    <p className="tableheadIndi">Hold</p>
                    <p className="tableheadIndi">Closed</p>
                    <p className="tableheadIndi">Completed</p>
                  </div>
                  <div>
                    {summaryList.map((summary, index) => (
                      <div className="tableRow" style={{ minWidth: "900px" }} key={index}>
                        <div className="tableheadIndi" title={`${summary.code ?? ""}-${summary.name ?? ""}`}>
                          {summary.code ?? ""}-{summary.name ?? ""}
                        </div>
                        <div className="tableheadIndi">{summary.overall ?? 0} </div>
                        <div className="tableheadIndi">
                          {summary.open ?? 0} <span className="circle-purple " /> <span className="text-purple"> {summary.open_percentage ?? 0}%</span>
                        </div>
                        <div className="tableheadIndi">
                          {summary.in_progress ?? 0} <span className="circle-purple " /> <span className="text-purple"> {summary.in_progress_percentage ?? 0}%</span>
                        </div>
                        <div className="tableheadIndi">
                          {summary.hold ?? 0}
                          <span className="circle-purple " /> <span className="text-purple"> {summary.hold_percentage ?? 0}%</span>
                        </div>
                        <div className="tableheadIndi">
                          {summary.closed ?? 0} <span className="circle-purple " /> <span className="text-purple">{summary.closed_percentage ?? 0}%</span>
                        </div>
                        <div className="tableheadIndi">
                          {summary.completed ?? 0} <span className="circle-purple " /> <span className="text-purple">{summary.completed_percentage ?? 0}%</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <Row className="mt-3">
                  <Col>
                    <div className="d-flex align-items-center justify-content-start mx-3">
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#212129",
                        }}
                      >
                        Records per page :
                      </span>
                      <select
                        className="select3"
                        id="perpage"
                        value={itemsPerPage}
                        onChange={(event) => {
                          setItemsPerPage(Number(event.target.value));
                          setItemOffset(0);
                        }}
                        style={{
                          cursor: "pointer",
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "18.9px",
                          color: "#212129",
                          width: "56px",
                          height: "24px",
                          borderRadius: "10px",
                          border: "0.7px solid #E5E5E5",
                          padding: "0 4px",
                          backgroundColor: "#FFFFFF",
                        }}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                  </Col>
                  <Col>
                    <div className="d-flex justify-content-end">
                      <ReactPaginate previousLabel={<img src={lar} style={{ width: "12px", height: "12px" }} alt="previous" />} nextLabel={<img src={rar} style={{ width: "12px", height: "12px" }} alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} forcePage={Math.floor(itemOffset / Number(itemsPerPage))} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>{" "}
      </div>
    </Container>
  );
}
